import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tax } from '@app/shared/models/tax';
import { TaxService } from '@app/shared/services/taxes/tax.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-add-tax-value',
  templateUrl: './add-tax-value.component.html',
  styleUrls: ['./add-tax-value.component.scss'],
})
export class AddTaxValueComponent implements OnInit {
  tax: Tax = null;
  @Input() tax$: Observable<Tax>;
  @Output() complete: EventEmitter<string> = new EventEmitter();

  selection = '';

  constructor(private taxService: TaxService) { }

  ngOnInit(): void {
    this.tax$.subscribe((tax) => {
      this.tax = tax;

      if (tax.charge_type === 'percent' && tax.subjects && tax.subjects.length > 0) {
        const names = [];
        for (let i = 0; i < tax.subjects.length; i++) {
          names.push(this.taxService.getFriendlySubjectLabel(tax.subjects[i]));
          this.selection = names.join(', ');
        }
      }

      if (tax.charge_type === 'fixed' && tax.calculation_type) {
        this.selection = this.taxService.getFriendlyCalculationTypeLabel(tax.calculation_type);
      }
    });
  }

  validateValueExistsIsPositive(): boolean {
    if (!this.tax.value || this.tax.value < 0) {
      return false;
    }

    return true;
  }

  progress() {
    if (!this.validateValueExistsIsPositive()) {
      return;
    }

    this.complete.emit('scope');
  }

  back() {
    this.complete.emit('duration');
  }
}
